import { Glyph } from "./Glyph";
import type { Ref } from "react";
import { cn } from "@/lib/utils";
import { FOCUS_RING } from "./focusRing.constants";
interface CheckboxProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
  id?: string;
  className?: string;
  "aria-label"?: string;
  "aria-labelledby"?: string;
  ref?: Ref<HTMLButtonElement>;
}
export function Checkbox({
  checked,
  onCheckedChange,
  disabled,
  id,
  className,
  ref,
  ...aria
}: CheckboxProps) {
  return <button ref={ref} type="button" role="checkbox" aria-checked={checked} id={id} disabled={disabled} onClick={() => !disabled && onCheckedChange(!checked)} className={cn("inline-flex h-[18px] w-[18px] shrink-0 items-center justify-center rounded-small transition-colors", FOCUS_RING, checked ? "bg-ink text-surface" : "bg-surface shadow-control", disabled && "cursor-not-allowed bg-offwhite text-ink-3 shadow-none", className)} {...aria} data-sentry-component="Checkbox" data-sentry-source-file="Checkbox.tsx">
            {checked && <Glyph name="check" className="h-3 w-3" strokeWidth={2.25} />}
        </button>;
}